export const ADVERT_COOKIE_NAME = 'alert-girls';
export const ADVERT_COOKIE_VALUE = 'accepted';
export const ADVERT_COOKIE_EXPIRES_DAYS = 36500;
